/**
 * AddFeaturedRowItemsCtrl controller
 */
// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

// controller mixins
AddFeaturedRowItemsCtrl.mixes = [
  'openPopupCtrlMixin'
]

/**
 * AddFeaturedRowItemsCtrl controller
 *
 * @class AddFeaturedRowItemsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:openPopupCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddFeaturedRowItemsCtrl
 */
/* @ngInject */
export default function AddFeaturedRowItemsCtrl ($uibModal, $uibModalInstance, $location, $scope, alertLiteSvc, carousel, type, contentItems, subscriptionIds) {
  var vm = this
  vm.subscriptionIds = subscriptionIds
  vm.type = type
  vm.removedItems = []

  vm.contentItems = { assigned: { }, available: { } }
  vm.contentItems.assigned.items = angular.copy(contentItems)
  vm.initialAssigned = angular.copy(contentItems)

  vm.carousel = carousel

  vm.availableFilter = ''
  vm.assignedFilter = ''
  vm.isFormDisabled = true

  /**
   * Table state for pageable request
   *
   * @memberof mwApp/packages.controller:AddContentSets
   * Ctrl
   */
  vm.initListState = {
    page: 0,
    count: 25,
    q: '',
    last: false,
    contentType: type,
    subscriptionIds
  }

  vm.contentTypes = {
    TV_CHANNEL: 'Channels',
    TV_SHOW: 'TV Shows',
    VOD: 'Movies'
  }

  /**
   * Filter users, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:FeaturedCarouselCtrl
   * @param  resetState boolean
   */
  vm.getAvailableItems = function (resetState = false) {
    if (resetState) {
      vm.listState = angular.copy(vm.initListState)
      vm.listState.q = vm.availableFilter
    } else {
      vm.listState.page++
    }
    vm.loading = true
    carousel._loadItems({ ...vm.listState })
      .then((res) => {
        vm.listState.last = res.last
        vm.listState.page = res.number
        if (resetState) {
          vm.contentItems.available.items = res.content.filter(c => !vm.contentItems.assigned.items.find(item => item.contentId === c.contentId))
        } else {
          vm.contentItems.available.items = vm.contentItems.available.items.concat(res.content.filter(c => !vm.contentItems.assigned.items.find(item => item.contentId === c.contentId)))
        }
        if (!vm.contentItems.available.items.length && !res.last) {
          vm.getAvailableItems()
        } else {
          vm.loading = false
        }
      }).catch(err => {
        vm.loading = false
        alertLiteSvc.alertError(err)
      })
  }

  vm.getAvailableItems(true)

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index, event) {
    event.stopPropagation()
    list.items = list.items
      .slice(0, index)
      .concat(items)
      .concat(list.items.slice(index))
    items.forEach(item => { item.selected = !item.selected })
    vm.isFormDisabled = false
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    link.selected = true
    return list.filter(link => link.selected)
  }
  /**
   * Delete item from contentItems
   *
   * @memberof mwApp/addFeaturedRowItems.controller:AddFeaturedRowItemsCtrl
   */
  vm.deleteItem = function (item, event) {
    event.preventDefault()
    item.selected = false
    vm.contentItems.assigned.items = vm.contentItems.assigned.items.filter(i => i.contentId !== item.contentId)
    if (!vm.contentItems.available.items.find(i => i.contentId === item.contentId)) {
      vm.contentItems.available.items.push(item)
    }
    vm.isFormDisabled = false
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.forEach(item => {
      item.selected = false
    })
    list.dragging = false
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list.items = list.items.filter(item => !item.selected)
  }

  /**
   * Create or edit season, and close modal window afterwards
   *
   * @memberof mwApp/addContentSets.controller:AddFeaturedRowItemsCtrl
   */
  vm.submit = function () {
    $uibModalInstance.close(vm.contentItems.assigned.items)
  }

  /**
   * Method for filtering sets by name
   *
   * @param {Object} contentItem
   * @memberof mwApp/packages.controller:AddAddonsCtrl
   */
  vm.filteredAssigned = (contentItem) => {
    return vm.assignedFilter.length > 0
      ? contentItem.name.toLowerCase().includes(vm.assignedFilter.toLowerCase())
      : true
  }

  /**
   * Method for filtering sets by name
   *
   * @param {Object} contentItem
   * @memberof mwApp/packages.controller:AddAddonsCtrl
   */
  vm.filteredAvailable = (contentItem) => {
    return vm.availableFilter.length > 0
      ? contentItem.name.toLowerCase().includes(vm.availableFilter.toLowerCase())
      : true
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/addContentSets.controller:AddFeaturedRowItemsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
  vm.access = {
    channelSets: 'editChannel',
    tvShowSets: 'editVodSeries',
    liveEventSets: 'editLiveEvent',
    vodSets: 'editVod'
  }
}
